import { isPS, replaceLocationHost } from '@/utils';
import { z } from 'zod';

export const AttachmentBaseModel = z.object({
  id: z.string().uuid(),
  createdAt: z.string(),
  updatedAt: z.string(),
  fileContentType: z.string(),
  fileName: z.string(),
  url: z.string().url().nullable(), // NOTE: NULL is returned for files that need to be sanitized.
  presignedUrl: z.string().url().nullish(),
  resourceType: z.number().nullable(),
  objectId: z.string().uuid().nullable(),
  sortOrder: z.number(),
});

export const AttachmentModel = AttachmentBaseModel.transform((v) => {
  return {
    ...v,
    // 見える化サイトの場合、proxyが存在しないため、URLのホスト名を置き換えない
    url: v.url && replaceLocationHost(v.url, !isPS()),
    presignedUrl:
      v.presignedUrl && replaceLocationHost(v.presignedUrl, !isPS()),
  };
});
export const AttachmentsModel = z.array(AttachmentModel);

export const SanitizedAttachmentModel = z.object({
  url: z.string().url(),
});

export const AttachmentSchema = AttachmentBaseModel.pick({
  fileName: true,
  fileContentType: true,
});

export const AttachmentUploadSchema = z
  .object({
    presignedUrl: z.string(),
    // NOTES: nodeをv20に上げるまではReferenceError: File is not definedが出るので、customを使う
    // ref. https://github.com/colinhacks/zod/issues/387#issuecomment-1774603011
    file: z.custom<File>((v) => v instanceof File),
  })
  .transform((v) => {
    return {
      ...v,
      // 見える化サイトの場合、proxyが存在しないため、URLのホスト名を置き換えない
      presignedUrl: replaceLocationHost(v.presignedUrl, !isPS()),
    };
  });
